const actions = {
  storeError({state}, payload) {
    state.errors.push(payload)
  },
  storeWarn({state}, payload) {
    state.warns.push(payload)
  },
  storeInfo({state}, payload) {
    state.info.push(payload)
  },
}

export default actions
